import { CQLGeoserver } from "./CQLGeoserver.js";

export { SQLEsri }

class SQLEsri extends CQLGeoserver {

    static getFilterParams(harmonizedFilters) {
        const filter = super.getFilterParams(harmonizedFilters);
        return (filter.cql_filter) ? { query: filter.cql_filter } : {};
    }

}